import { Box } from '@chakra-ui/react'
import React, { useState } from 'react'
import { MFA } from '../MFA/MFA'
import { FormLogin } from './FormLogin'
import { DataUser } from './interface'

const SignIn: React.FC = () => {
    const [dataUser, setDataUser] = useState<DataUser>()

    return (
        <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            color="blackAlpha.900"
            bgColor="backdrop"
            h="100vh"
            w="100%"
        >
            {!dataUser?.session ? (
                <FormLogin setDataUser={setDataUser} />
            ) : (
                <MFA dataUser={dataUser} />
            )}
        </Box>
    )
}

export default SignIn
